"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meetings = exports.meetingConstants = void 0;
const gearbox_1 = require("@busy-human/gearbox");
const firestore_1 = require("firebase/firestore");
const Transactions_1 = require("../Transactions");
const moment_1 = __importDefault(require("moment"));
const libPackage = require("../../../package.json");
const VERSION = libPackage.version;
exports.meetingConstants = {
    DEFAULT_LENGTH: 30,
    DEFAULT_PRICE: 50,
    MINIMUM_LENGTH: 1,
    MAXIMUM_LENGTH: 360,
    MINIMUM_PRICE: 1,
    MAXIMUM_PRICE: 2000,
};
var Meetings;
(function (Meetings) {
    let MeetingStatus;
    (function (MeetingStatus) {
        /** The meeting is proposed but not yet scheduled */
        MeetingStatus["proposed"] = "proposed";
        /** The meeting has been scheduled but has not yet taken place (The meeting is scheduled when the payment capture is attempted)*/
        MeetingStatus["scheduled"] = "scheduled";
        /** One of the parties (for now, the sender) has requested the other party reschedule */
        MeetingStatus["rescheduleRequested"] = "rescheduleRequested";
        /** The meeting start time has passed */
        MeetingStatus["meetingStarted"] = "meetingStarted";
        /** The meeting end time has passed */
        MeetingStatus["meetingEnded"] = "meetingEnded";
        /** The meeting has been successfully canceled */
        MeetingStatus["canceled"] = "canceled";
        /** The meeting is being contested by either party */
        MeetingStatus["contested"] = "contested";
        /** The meeting has been confirmed by the collector (payee) */
        MeetingStatus["collectorConfirmed"] = "collectorConfirmed";
        /** The meeting has been confirmed by the payer */
        MeetingStatus["payerConfirmed"] = "payerConfirmed";
        /** The meeting has been confirmed by BOTH parties */
        MeetingStatus["fullyConfirmed"] = "fullyConfirmed";
        /** The meeting was confirmed by admin intervention */
        MeetingStatus["adminConfirmed"] = "adminConfirmed";
        /** The meeting was not confirmed within the allowed time period */
        MeetingStatus["unconfirmed"] = "unconfirmed";
    })(MeetingStatus = Meetings.MeetingStatus || (Meetings.MeetingStatus = {}));
    function Defaults() {
        return {
            startTime: '',
            endTime: '',
            price: { "currency": "$", "amount": 1, "gross": 1 },
            payer: "",
            payerLink: "",
            collector: "",
            collectorLink: "",
            sendersNote: '',
            receiversNote: '',
            sendersContactInfo: '',
            receiversContactInfo: '',
            from: 'payer',
            invite: "",
            previousMeeting: "",
            collectorOptTransactionId: null,
            payerOptTransactionId: null,
            paymentStatus: null,
            reminderSent: false,
            location: null,
            clientMissed: false,
            collectorMissed: false,
            isCancelled: false,
            transactionId: null,
            status: MeetingStatus.scheduled,
            problemReports: []
        };
    }
    Meetings.Defaults = Defaults;
    function Validate(data) {
        const raw = data;
        const fail = (reason) => {
            return { isValid: false, reason };
        };
        if (typeof raw.startTime !== 'string')
            return fail("startTime must be a string");
        if (typeof raw.endTime !== 'string')
            return fail('endTime must be a string');
        if (typeof raw.price !== 'object')
            return fail("Price must be an object");
        if (typeof raw.price.currency !== 'string' || raw.price.currency !== '$')
            return fail("Currency must be a string");
        if (typeof raw.price.amount !== 'number')
            return fail("Price Amount must be a number");
        if (typeof raw.payer !== 'string')
            return fail("Payer must be a string");
        if (typeof raw.payerLink !== 'string')
            return fail("payerLink must be a string");
        if (typeof raw.collector !== 'string')
            return fail('Collector must be a string');
        if (typeof raw.collectorLink !== 'string')
            return fail('collectorLink must be a string');
        if (typeof raw.location !== 'object')
            return fail("Location must be an object of Location Data");
        if (raw.collectorOptTransactionId !== null && typeof raw.collectorOptTransactionId !== 'string')
            return fail('collectorOptTransactionId must be null or a string');
        if (raw.payerOptTransactionId !== null && typeof raw.payerOptTransactionId !== 'string')
            return fail('payerOptTransactionId must be null or a string');
        if (raw.paymentStatus !== null && !Object.values(Transactions_1.Transactions.TransactionStatus).includes(raw.paymentStatus))
            return fail('paymentStatus must be a TransactionStatus');
        if (typeof raw.clientMissed !== 'boolean')
            return fail('clientMissed must be a boolean');
        if (typeof raw.collectorMissed !== 'boolean')
            return fail('collectorMissed must be a boolean');
        if (typeof raw.isCancelled !== 'boolean')
            return fail('isCancelled must be a boolean');
        if (typeof raw.meetingLength !== 'undefined' && typeof raw.meetingLength !== 'number')
            return fail('meetingLength must be a number');
        if (raw.transactionId !== null && typeof raw.transactionId !== 'string')
            return fail('transactionId must be null or a string');
        if (typeof raw.sendersNote !== 'string')
            return fail('Sender note must be a string');
        if (typeof raw.receiversNote !== 'string')
            return fail('Receiver note must be a string');
        if (typeof raw.sendersContactInfo !== 'string')
            return fail('Sender contact info must be a string');
        if (typeof raw.receiversContactInfo !== 'string')
            return fail('Receiver contact info must be a string');
        if (raw.from !== 'payer' && raw.from !== 'collector')
            return fail('From must be payer or collector');
        if (typeof raw.invite !== 'string')
            return fail('invite must be a string');
        if (typeof raw.previousMeeting !== 'string')
            return fail('previousMeeting must be a string');
        let statuses = Object.keys(MeetingStatus);
        let validStatus = false;
        for (let status in statuses) {
            if (status === raw.status) {
                validStatus = true;
                break;
            }
        }
        if (!validStatus)
            return fail('status must be pending, processing, or completed');
        const tmp = {
            startTime: raw.startTime,
            endTime: raw.endTime,
            price: {
                currency: raw.price.currency,
                amount: raw.price.amount,
                gross: raw.price.amount
            },
            payer: raw.payer,
            payerLink: raw.payerLink,
            collector: raw.collector,
            collectorLink: raw.collectorLink,
            sendersNote: raw.sendersNote,
            receiversNote: raw.receiversNote,
            sendersContactInfo: raw.sendersContactInfo,
            receiversContactInfo: raw.receiversContactInfo,
            from: raw.from,
            invite: raw.invite,
            previousMeeting: raw.previousMeeting,
            collectorOptTransactionId: raw.collectorOptTransactionId,
            payerOptTransactionId: raw.payerOptTransactionId,
            paymentStatus: raw.paymentStatus,
            clientMissed: raw.clientMissed,
            collectorMissed: raw.collectorMissed,
            isCancelled: raw.isCancelled,
            reminderSent: raw.reminderSent,
            location: raw.location,
            transactionId: raw.transactionId,
            status: raw.status
        };
        if (raw.meetingLength)
            tmp.meetingLength = raw.meetingLength;
        return { isValid: true, model: tmp };
    }
    Meetings.Validate = Validate;
    function isMeetingConfirmed(meeting) {
        switch (meeting.status) {
            case MeetingStatus.payerConfirmed:
            // We may not want to include collectorConfirmed in the future here. 
            // Its much more likely the person getting paid will want to confirm the meeting than the person paying
            case MeetingStatus.collectorConfirmed:
            case MeetingStatus.fullyConfirmed:
            case MeetingStatus.adminConfirmed:
                return true;
            default:
                return false;
        }
    }
    Meetings.isMeetingConfirmed = isMeetingConfirmed;
    function generateICS(meeting, other) {
        return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//LEANMEET//OPTME v${VERSION}//EN
BEGIN:VEVENT
UID:${meeting.$id}
DTSTAMP:${meeting.startTime.replace(/[-:.]/g, '').substring(0, 15)}Z
DTSTART:${meeting.startTime.replace(/[-:.]/g, '').substring(0, 15)}Z
SUMMARY:Meeting with ${other.name.fullName}
DESCRIPTION:${meeting.sendersNote}
DTEND:${meeting.endTime.replace(/[-:.]/g, '').substring(0, 15)}Z
ORGANIZER;CN="OptMe":mailto:do_not_reply@optme.com
END:VEVENT
END:VCALENDAR`;
    }
    Meetings.generateICS = generateICS;
    function canMeetingBeConfirmed(meeting) {
        let now = (0, moment_1.default)();
        switch (meeting.status) {
            case MeetingStatus.scheduled:
            case MeetingStatus.meetingStarted:
                if ((0, moment_1.default)(meeting.endTime).isSameOrBefore(now, "hour")) {
                    meeting.status = MeetingStatus.meetingEnded;
                }
                break;
        }
        switch (meeting.status) {
            case MeetingStatus.meetingStarted:
            case MeetingStatus.meetingEnded:
            case MeetingStatus.payerConfirmed:
            case MeetingStatus.collectorConfirmed:
                return true;
            case MeetingStatus.unconfirmed:
                if (meeting.paymentStatus == "available" || meeting.paymentStatus == "posted")
                    return true;
                else
                    return false;
            default:
                return false;
        }
    }
    Meetings.canMeetingBeConfirmed = canMeetingBeConfirmed;
    function canMeetingBeRescheduled(meeting) {
        let now = (0, moment_1.default)();
        switch (meeting.status) {
            case MeetingStatus.canceled:
            case MeetingStatus.contested:
            case MeetingStatus.collectorConfirmed:
            case MeetingStatus.payerConfirmed:
            case MeetingStatus.fullyConfirmed:
                return false;
            default:
                return true;
        }
    }
    Meetings.canMeetingBeRescheduled = canMeetingBeRescheduled;
    class CollectionClass extends gearbox_1.CollectionEntity {
        constructor() {
            super(...arguments);
            this.relationships = {};
        }
        defaults() {
            return Defaults();
        }
        fetchAllUserMeetings(userId) {
            return __awaiter(this, void 0, void 0, function* () {
                const allRequests = [];
                const collectorDocs = yield this.subset(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("collector", "==", userId))).fetch();
                const payerDocs = yield this.subset(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("payer", "==", userId))).fetch();
                let allDocs = collectorDocs.concat(payerDocs);
                allDocs.forEach((doc) => {
                    allRequests.push(doc.data());
                });
                return allRequests;
            });
        }
        fetchMeetingForLink(link) {
            return __awaiter(this, void 0, void 0, function* () {
                const payerTmp = yield this.fetchDocWithQuery(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("payerLink", "==", link)));
                if (payerTmp)
                    return { meeting: payerTmp.data(), type: 'payer' };
                const collectorTmp = yield this.fetchDocWithQuery(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("collectorLink", "==", link)));
                if (collectorTmp)
                    return { meeting: collectorTmp.data(), type: 'collector' };
                return null;
            });
        }
        inviteUsedByUser(link, userId) {
            return __awaiter(this, void 0, void 0, function* () {
                const cTmp = yield this.fetchDocWithQuery(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("invite", "==", link), (0, firestore_1.where)("collector", "==", userId)));
                if (cTmp)
                    return true;
                const pTmp = yield this.fetchDocWithQuery(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("invite", "==", link), (0, firestore_1.where)("payer", "==", userId)));
                if (pTmp)
                    return true;
                return false;
            });
        }
    }
    Meetings.CollectionClass = CollectionClass;
    Meetings.Collection = new CollectionClass({ path: '/Meetings' });
})(Meetings = exports.Meetings || (exports.Meetings = {}));
//# sourceMappingURL=index.js.map